import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { admin, type AdminAuthEvent } from '../../api/admin'
import { ApiError } from '../../api/client'

const KINDS = [
  'login_success',
  'login_failure',
  'signup',
  'google_success',
  'google_failure',
  'access_granted',
  'access_revoked',
  'user_created',
  'user_updated',
]

export function AdminEvents() {
  const [params, setParams] = useSearchParams()
  const kind = params.get('kind') ?? ''
  const sinceDays = params.get('since_days') ?? ''
  const [events, setEvents] = useState<AdminAuthEvent[] | null>(null)
  const [total, setTotal] = useState(0)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    setError(null)
    admin.authEvents({
      kind: kind || undefined,
      since_days: sinceDays ? Number(sinceDays) : undefined,
    })
      .then((r) => {
        setEvents(r.events)
        setTotal(r.total)
      })
      .catch((e) => setError(e instanceof ApiError ? e.message : 'Error de red.'))
  }, [kind, sinceDays])

  return (
    <section>
      <div className="page-header">
        <h1>Eventos de auth</h1>
        <p className="text-sm text-text-muted">{total} eventos</p>
      </div>
      {error && <div className="banner-err mb-md">{error}</div>}

      <div className="filter-bar">
        <label className="flex items-center gap-sm">
          Tipo:
          <select
            className="input w-auto"
            value={kind}
            onChange={(e) => {
              const next = new URLSearchParams(params)
              if (e.target.value) next.set('kind', e.target.value)
              else next.delete('kind')
              setParams(next)
            }}
          >
            <option value="">todos</option>
            {KINDS.map((k) => (
              <option key={k} value={k}>
                {k}
              </option>
            ))}
          </select>
        </label>
        <label className="flex items-center gap-sm">
          Últimos:
          <select
            className="input w-auto"
            value={sinceDays}
            onChange={(e) => {
              const next = new URLSearchParams(params)
              if (e.target.value) next.set('since_days', e.target.value)
              else next.delete('since_days')
              setParams(next)
            }}
          >
            <option value="">siempre</option>
            <option value="1">1 día</option>
            <option value="7">7 días</option>
            <option value="30">30 días</option>
          </select>
        </label>
      </div>

      <div className="table-wrap">
        <table>
          <thead>
            <tr>
              <th>Cuándo</th>
              <th>Tipo</th>
              <th>Usuario</th>
              <th>Identificador</th>
              <th>Detalle</th>
              <th>IP</th>
            </tr>
          </thead>
          <tbody>
            {events === null && (
              <tr>
                <td colSpan={6} className="text-text-muted">
                  Cargando…
                </td>
              </tr>
            )}
            {events?.length === 0 && (
              <tr>
                <td colSpan={6} className="text-center text-text-muted">
                  Sin eventos con esos filtros.
                </td>
              </tr>
            )}
            {events?.map((e) => (
              <tr key={e.id}>
                <td>{new Date(e.ts).toLocaleString('es-AR', { dateStyle: 'short', timeStyle: 'short' })}</td>
                <td>
                  <span
                    className={
                      e.kind.endsWith('_failure')
                        ? 'tag-err'
                        : e.kind.endsWith('_success') ||
                          ['signup', 'access_granted', 'user_created', 'user_updated'].includes(e.kind)
                        ? 'tag-ok'
                        : 'tag'
                    }
                  >
                    {e.kind}
                  </span>
                </td>
                <td>{e.user_id ?? '—'}</td>
                <td>{e.identifier ?? '—'}</td>
                <td className="text-xs text-text-muted">{e.detail ?? '—'}</td>
                <td className="text-text-muted">{e.ip ?? '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  )
}
